import React, { forwardRef } from "react";
import FormInput from "semantic-ui-react/dist/es/collections/Form/FormInput";

const VmoFormInput = forwardRef((props, ref) => {
  return (
    <React.Fragment>
      <FormInput {...props} ref={ref}>
        {props.children}
      </FormInput>
      {props?.maxLength && (
        <div className="input-cnt">
          {props?.value?.length ? props?.value?.length : 0}/{props?.maxLength}
        </div>
      )}
    </React.Fragment>
  );
});
export default VmoFormInput;
